import { createApp } from 'vue';
import NrwToJpgConverter from '../Components/NrwToJpgConverter.vue';

const root = document.getElementById('nrw-to-jpg-converter');
if (root) {
  createApp(NrwToJpgConverter).mount('#nrw-to-jpg-converter');
}
